import { Patch } from 'immer';
import { UserStorageDataType } from '../../../core/database/schemas';
import { PartialSheetViews } from './view';
import { CommandHistory, SheetManagementSet } from './draft';

export interface SheetsChanges {
  [key: string]: Patch[];
}

export interface SheetHistory {
  activeGroupId?: string;
  activeSheetId?: string;
  groups?: Patch[];
  sheetsIdToName?: Patch[];
  sheetRoot?: Patch[];
  sheets?: SheetsChanges;
  sheetViews?: PartialSheetViews;
}

export enum HistoryActionType {
  Undo = "U",
  Redo = "R"
}

export interface SheetManagerHistory {
  past: SheetHistory[];
  // present: SheetHistory
  presentSheetViews?: PartialSheetViews;
  future: SheetHistory[];
}

export interface UnSavedSheetHistory {
  historyAction:
    | UserStorageDataType.History
    | UserStorageDataType.Undo
    | UserStorageDataType.Redo;
  past: SheetHistory;
}

export interface SheetUnSavedChanges {
  [sheetId: string]: Patch[][];
}
export interface UnSavedSheetsChanges {
  sheetsIdToName: Patch[][];
  groups: Patch[][];
  sheetRoot: Patch[][];
  sheets: SheetUnSavedChanges;
}

export interface SheetsHistory {
  past: Partial<CommandHistory>[];
  future: Partial<CommandHistory>[];
}

export type ChangesToBeSaved = Partial<CommandHistory> &
  Pick<SheetManagementSet, 'id'>;
